import { Customer } from "@/models/customer";
import { Relay, RELAY_POINT_NAME_PREFIX } from "@/models/relay";

export class Address {
  firstName!: string;
  lastName!: string;
  company!: string;
  street!: string;
  city!: string;
  postCode!: string;
  country!: string;
  phone!: string;
  email!: string;
  website?: string;
  latitude!: number;
  longitude!: number;
  name!: string;

  public static of(data: any): Address {
    const a: Address = new Address();
    a.firstName = data?.firstName;
    a.lastName = data?.lastName;
    a.company = data?.company;
    a.street = data?.street;
    a.city = data?.city;
    a.postCode = data?.postCode;
    a.country = data?.country;
    a.phone = data?.phone;
    a.email = data?.email;
    a.website = data?.website;
    a.latitude = data?.latitude;
    a.longitude = data?.longitude;
    a.name = data?.name || '';

    return a;
  }

  public static ofRelay(customer: Customer, relay: Relay): Address {
    const a: Address = new Address();
    a.firstName = customer.firstName;
    a.lastName = customer.lastName;
    a.company = relay.company;
    a.street = relay.street;
    a.city = relay.city;
    a.postCode = relay.postCode;
    a.country = relay.country;
    a.phone = relay.phone;
    a.email = customer.email;
    a.latitude = relay?.latlng?.lat;
    a.longitude = relay?.latlng?.lng;
    a.name = relay.name;

    return a;
  }

  isRelayAddress() {
    return this.name.startsWith(RELAY_POINT_NAME_PREFIX);
  }
}